import { NavLink } from 'react-router-dom';
import { Badge } from 'reactstrap';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link } from '@s20/components/common/Link';
import { useSelector } from '@s20/hooks/redux.hooks';
import { getPermissionStrings } from '@s20/selectors/features/permissions.selectors';
import { FlexBetweenRow, FlexStartRow, IconButton } from '../common/forms/FormElements';
import { Can } from '../Can';

export const NavMenuItem = ({
    entity, action, searchUrl, label, newTitle,
    searchTitle, onNavLinkClicked, hideNew, newUrl,
    notificationCount, icon, name,
    DraggableProps = null, editing = false,
}) => {
    const permissions = useSelector(getPermissionStrings);

    if (!permissions.includes(`${entity}.${action}`))
        return null;

    const canEdit = Boolean(editing && DraggableProps?.provided);

    return (
        <NavLink
            to={searchUrl}
            title={searchTitle}
            onClick={(e) => onNavLinkClicked(e, name)}
            className={cls('nav-menu-item list-group-item-action list-group-item', editing && 'editing')}
        >
            <FlexBetweenRow className="w-100">
                <FlexStartRow className="align-items-center">
                    {canEdit && (
                        <div
                            className="dragIndicator mr-1"
                            {...DraggableProps.provided.dragHandleProps}
                        >
                            <FontAwesomeIcon icon={faGripVertical} />
                        </div>
                    )}

                    {Boolean(icon) && (
                        <div className="menu-icon">
                            <FontAwesomeIcon icon={icon} />
                        </div>
                    )}

                    <span>{label}</span>

                    {!!notificationCount && (
                        <Badge
                            color="danger"
                            className="nav-menu-notification-badge ml-1"
                        >
                            {notificationCount}
                        </Badge>
                    )}

                    {!hideNew && Boolean(newUrl) && (
                        <Can
                            I="create"
                            a={entity}
                        >
                            <Link
                                to={newUrl}
                                title={newTitle}
                                onClick={onNavLinkClicked}
                                className="ml-2"

                            >
                                <Badge color="secondary">
                                    <FontAwesomeIcon icon={faPlus} />
                                    Add
                                </Badge>
                            </Link>
                        </Can>
                    )}
                </FlexStartRow>

                {canEdit && (
                    <IconButton
                        title="Remove Quick Link"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            DraggableProps.handleRemoveShortcut();
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faTimes}
                            className="text-muted"
                        />
                    </IconButton>
                )}
            </FlexBetweenRow>
        </NavLink>
    );
};